const apiRoutes = {
  openSearchUniversitiesList: "/api/v1/universities/search",
};
 
export default apiRoutes;
